import { ButtonBase } from '@mui/material'
import { SPEAK_MODES } from './aiAskBarSpeakModes'
import styles from './index.module.scss'

/**
 * The composer's one primary control, and its only send affordance.
 *
 * Rather than a row of separate buttons it carries every state in one place —
 * Speak, send, stop-voice, stop-generating — so the action the user reaches for
 * is always under the same pixel. The label drops on narrow composers (a CSS
 * concern, see `.speakLabel`), leaving the icon alone.
 */
export default function AiAskBarSpeakButton({ mode, onClick, disabled = false }) {
  const { label, aria, Icon, tone, size } = SPEAK_MODES[mode]

  return (
    <ButtonBase
      type="button"
      className={[
        styles.speakButton,
        tone === 'ink' ? styles.speakButtonInk : '',
        size === 'circle' ? styles.speakButtonCircle : '',
        mode === 'stopVoice' ? styles.speakButtonLive : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={aria}
      aria-pressed={mode === 'stopVoice'}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon className={size === 'circle' ? styles.speakIconSmall : styles.speakIcon} aria-hidden />
      {label ? <span className={styles.speakLabel}>{label}</span> : null}
    </ButtonBase>
  )
}
